import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-printer-driver',
  templateUrl: './page-printer-driver.component.html',
  styleUrls: ['./page-printer-driver.component.css']
})
export class PagePrinterDriverComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
